import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// KB Portal Search with debounce
// Uses @rails/request.js for CSRF-safe requests.
// Results are rendered server-side via a partial and inserted into a
// dedicated results container. The server partial is trusted (same-origin),
// matching the pattern used by other support Stimulus controllers.
//
// data-controller="support--kb-search"
export default class extends Controller {
  static targets = ["input", "results", "empty", "categories"]
  static values = { url: String, minLength: { type: Number, default: 3 } }

  connect() {
    this._timeout = null
  }

  disconnect() {
    if (this._timeout) clearTimeout(this._timeout)
  }

  search() {
    if (this._timeout) clearTimeout(this._timeout)

    const query = this.inputTarget.value.trim()

    if (query.length < this.minLengthValue) {
      this._clearResults()
      return
    }

    this._timeout = setTimeout(() => this._performSearch(query), 300)
  }

  clear() {
    this.inputTarget.value = ""
    this._clearResults()
  }

  async _performSearch(query) {
    try {
      const response = await get(this.urlValue, {
        query: { q: query },
        responseKind: "turbo-stream",
      })

      if (response.ok) {
        // @rails/request.js with turbo-stream responseKind auto-processes
        // Turbo Stream responses. For HTML partials, fall back to text insertion.
        const html = await response.text
        if (html && this.hasResultsTarget) {
          this.resultsTarget.replaceChildren()
          const template = document.createElement("template")
          template.innerHTML = html
          this.resultsTarget.appendChild(template.content)
          this.resultsTarget.classList.remove("hidden")

          if (this.hasCategoriesTarget)
            this.categoriesTarget.classList.add("hidden")

          const hasResults =
            this.resultsTarget.querySelector("[data-kb-result]")
          if (this.hasEmptyTarget) {
            this.emptyTarget.classList.toggle("hidden", !!hasResults)
          }
        }
      }
    } catch (e) {
      console.error("[kb-search] Search failed:", e)
    }
  }

  _clearResults() {
    if (this.hasResultsTarget) {
      this.resultsTarget.replaceChildren()
      this.resultsTarget.classList.add("hidden")
    }
    if (this.hasCategoriesTarget)
      this.categoriesTarget.classList.remove("hidden")
    if (this.hasEmptyTarget) this.emptyTarget.classList.add("hidden")
  }
}
